import React from 'react';
import { BaseDropdown, DropdownOption } from 'components/Analytics/Filters/dropdown/dropdown';

interface FilterDropdownProps {
    value: string[];
    options: DropdownOption<string>[];
    placeholder: string;
    filterPlaceholder: string;
    onChange: (value: string[]) => void;
}

export const FilterDropdown: React.FC<FilterDropdownProps> = (props) => {
    const {
        value,
        options,
        ...rest
    } = props;

    const getSelectedItemsLabel = () => {
        if (!value.length) return '';

        const firstItem = options.find(opt => opt.value === value[0]);

        if (firstItem && value.length > 1) {
            return `${firstItem.label} +${value.length - 1}`;
        }

        return firstItem?.label ?? '';
    };

    return (
        <BaseDropdown<string>
            {...rest}
            multiple={true}
            value={value}
            options={options}
            filter
            showClear
            maxSelectedLabels={1}
            selectedItemsLabel={getSelectedItemsLabel()}
            panelClassName="analytic-select-panel"
            className={`analytic-select ${value.length ? 'has-selected-items' : ''}`}
        />
    );
};